import React from "react";
import { Modal, Box, Typography, IconButton, Tooltip } from "@mui/material";
import { Form, Button, Alert } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import "../CustomStyle.css";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const PdfPreviewModal = ({
  isModalOpen,
  handleClose,
  pdfImageSrc,
  selectedTemplate,
  handleDownloadPdf,
  theme,
  error,
  successMessage,
  templateName,
  setTemplateName,
  handleTemplateSave,
}) => {
  const Legend = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    background-color: ${({ theme }) =>
      theme === "dark" ? "rgb(14, 17, 23)" : "#fff"};
    padding: 10px;
    @media (max-width: 360px) {
      gap: 0; /* Remove spacing between items at 320px */
    }
  `;

  const LegendItem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 30px;
    font-size: 15px;
    color: ${({ theme }) => (theme === "dark" ? "white" : "#000")};

    span {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-right: 5px;
      background-color: ${({ color }) => color};
    }
    @media (max-width: 360px) {
      font-size: 12px; /* smaller text for 320px screens */
    }
  `;

  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    "& .MuiTooltip-tooltip": {
      backgroundColor: "black",
      color: "white",
      fontSize: "10px",
      borderRadius: "4px",
      padding: "8px",
    },
  });
  return (
    <Modal
      open={isModalOpen}
      aria-labelledby="pdf-preview-modal"
      aria-describedby="pdf-preview-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 744,
          maxHeight: "85vh",
          overflowY: "auto",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          "@media (max-width: 600px)": {
            width: "95%",
            p: 2,
          },
        }}
      >
        <IconButton
          onClick={handleClose}
          className="close-button"
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1,
            border: "1px solid #ccc",
            background: "transparent",
            "&:hover": {
              border: "1px solid green",
              color: "green",
              background: "transparent",
            },
            borderRadius: "20%",
          }}
        >
          <CloseIcon />
        </IconButton>
        <div className="modal-heading">
          <Typography
            id="pdf-preview-modal"
            variant="h5"
            component="h2"
            className="modal-title"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "1.5rem", sm: "1.75rem" },
            }}
          >
            {selectedTemplate}
          </Typography>
        </div>

        <div className="modal-form">
          <Form.Group controlId="templateName">
            <div className="modal-form-field">
              <Form.Label className="custom-label">
                Save Template As <span style={{ color: "red" }}> *</span>
              </Form.Label>
              <CustomTooltip
                title="Give a unique name for your Template"
                placement="top"
              >
                <IconButton sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}>
                  <HelpOutlineIcon sx={{ fontSize: 15 }} />
                </IconButton>
              </CustomTooltip>
            </div>
            <Form.Control
              type="text"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              placeholder="For ex: Final-Template-AgentLetter"
            />
          </Form.Group>
          <Button
            variant="success"
            onClick={handleTemplateSave}
            className="modal-button"
          >
            Save Template
          </Button>
        </div>
        {error && (
          <Alert variant="danger" className="modal-alert">
            {error}
          </Alert>
        )}
        {successMessage && (
          <Alert variant="success" className="modal-alert">
            {successMessage}
          </Alert>
        )}
        <div
          className="modal-legends"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          {/* Legend */}
          <Legend theme={theme}>
            <LegendItem theme={theme} color="darkviolet">
              <span></span>Prospect
            </LegendItem>
            <LegendItem theme={theme} color="brown">
              <span></span>Realtor
            </LegendItem>
            {selectedTemplate === "Agent Letter - Biro" ||
            selectedTemplate === "Agent Letter - Typed" ? (
              <LegendItem theme={theme} color="#FF6B35">
                <span></span>Campaign
              </LegendItem>
            ) : null}
          </Legend>

          <Button
            variant="success"
            onClick={handleDownloadPdf}
            className="modal-button"
            style={{
              marginLeft: "2%",
              marginBottom: "1.3%",
            }}
          >
            Download PDF
          </Button>
        </div>
        <div
          style={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            margin: "10px",
            padding: "10px",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "10px",
              boxSizing: "border-box",
              overflow: "hidden",
              width: "100%",
              maxWidth: "744px",
            }}
          >
            {pdfImageSrc ? (
              <img
                src={pdfImageSrc}
                style={{
                  width: "100%",
                  height: "auto",
                }}
                alt="PDF preview"
              />
            ) : (
              <p>Loading PDF preview</p>
            )}
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default PdfPreviewModal;
